import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6424fbce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "svg-wrapper" }
const _hoisted_2 = { viewBox: "0 0 24 24" }
const _hoisted_3 = ["d"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("path", { d: _ctx.path }, null, 8, _hoisted_3)
      ]))
    ])
  ]))
}